import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/webinargeek.webp';
import screenshot_target from '../../../images/letterfunnel/remcotreuren.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Remco Treuren"
      firstname="Remco"
      companyname="WebinarGeek"
      competition="Livestorm en Demio"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/remcotreuren.js